import { Component, inject } from '@angular/core';
import { AuthService } from '@app/components/login.component';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';
import {
  isNerazvrstanoJedinica,
  isRootJedinica
} from '@app/shared/util/common-utils';
import { isActionOnJedinicaDisabled } from '@app/shared/util/jedinica-gradiva-security-utils';
import { ServerItemAction } from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { delay, EMPTY, map, Observable, tap, withLatestFrom } from 'rxjs';

@Component({
  selector: 'app-promjena-poretka-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class PromjenaPoretkaActionComponent extends withTooltipState(
  ServerItemAction
) {
  private confirmationService = inject(ConfirmationService);
  private authService = inject(AuthService);

  key = 'order-popup';

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      withLatestFrom(this.authService.validUser$),
      map(([item, user]) => {
        // Fond/zbirka ne smiju mijenjati redoslijed (osim Nerazvrstano zbirke)
        if (isRootJedinica(item) && !isNerazvrstanoJedinica(item)) {
          return {
            disabled: true,
            message: 'Promjena redoslijeda za fond ili zbirku nije dozvoljena.'
          };
        }
        return isActionOnJedinicaDisabled(item, user);
      }),
      delay(0),
      map((result) => {
        this.setTooltip(result.message);
        return result.disabled;
      })
    );
  }

  protected override doExecute(): Observable<any> {
    this.confirmationService.confirm({
      message:
        'Jeste li sigurni da želite promijeniti poredak jedinice? Ova akcija će imati učinak promjene arhivske oznake na susjednu jedinicu i sve niže jedinice!',
      key: this.key,
      accept: () => {
        super
          .doExecute()
          .pipe(
            tap((result) => {
              this.tryShowNotification(result);
              if (!result.$infoMessage || result.$infoMessage?.msg === '') {
                // FIXME trebalo bi smisliti neki nacin da tree reloadamo samo djelomicno, ili da barem zadrzimo state koji su bili otvoreni prije
                this.listViewProvider.reload(); // moramo reload svega jer nemamo pojma sto se sve promijenilo
              }
            })
          )
          .subscribe();
      }
    });
    return EMPTY;
  }
}
